module.exports = __webpack_public_path__ + "static/media/pl.54f1ee71.svg";